module.exports = __webpack_public_path__ + "static/media/Post_After.348a4b09.jpg";